import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { noWhitespaceValidator } from '../../../utils/no-whitespace.validator';
import { MatExpansionModule } from '@angular/material/expansion';
import { SystemAdminService } from '../../../services/system-admin.service';
import { ToastService } from '../../../services/toast.service';
import { ToastType } from '../../../enums/config.enum';

@Component({
    selector: 'app-fileconfig',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, ReactiveFormsModule],
    templateUrl: './fileconfig.component.html',
    styleUrl: './fileconfig.component.scss'
})
export class FileconfigComponent implements OnInit {

    systemAdminService = inject(SystemAdminService);
    isfileConfigUpdate = signal<boolean>(false);
    configId = signal<number>(0);
    isReadonly = signal<boolean>(true);
    fb: FormBuilder = inject(FormBuilder);
    toastService = inject(ToastService);
    fileConfigForm = this.fb.group({
        docStorageType: [null, [Validators.required, noWhitespaceValidator]],
        docStoragePath: [null, [Validators.required, noWhitespaceValidator]],
        docMaxFileSize: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[0-9]+$')]],
        docAllowedExtensions: [null, [Validators.required, noWhitespaceValidator, Validators.pattern(/\.(jpeg|pdf|txt|docx)$/i)]],
        docUploadDirectory: [null, [Validators.required, noWhitespaceValidator]],
        docFileRetentionDays: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[0-9]+$')]],
        acordStorageType: [null, [Validators.required, noWhitespaceValidator,]],
        acordStoragePath: [null, [Validators.required, noWhitespaceValidator]],
        acordMaxFileSize: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[0-9]+$')]],
        acordAllowedExtensions: [null, [Validators.required, noWhitespaceValidator, Validators.pattern(/\.(xml|pdf)$/i)]],
        acordUploadDirectory: [null, [Validators.required, noWhitespaceValidator]],
        acordFileRetentionDays: [null, [Validators.required, noWhitespaceValidator, Validators.pattern('^[0-9]+$')]],
        docIsSecure: [false, [Validators.required, noWhitespaceValidator]],
        acordIsSecure: [false, [Validators.required, noWhitespaceValidator]],
    });

    ngOnInit(): void {
        this.getFileConfigDetails();
    }

    // onFileCongigSave()
    // {
    //   if (this.fileConfigForm.invalid)
    //     {
    //       this.fileConfigForm.markAllAsTouched();
    //       return;
    //     }

    // }
    toggleReadonly() {
        this.isReadonly.set(!this.isReadonly());
    }


    getFileConfigDetails() {
        this.systemAdminService.getFileConfig().subscribe({
            next: (response: any) => {
                if (response && response.length > 0) {
                    response.forEach((fileConfig: any) => {
                        // Process the single object in the response
                        this.fileConfigForm.patchValue({
                            docStorageType: fileConfig.docStorageType,
                            docStoragePath: fileConfig.docStoragePath,
                            docMaxFileSize: fileConfig.docMaxFileSize,
                            docAllowedExtensions: fileConfig.docAllowedExtensions,
                            docUploadDirectory: fileConfig.docUploadDirectory,
                            docFileRetentionDays: fileConfig.docFileRetentionDays,
                            acordStorageType: fileConfig.acordStorageType,
                            acordStoragePath: fileConfig.acordStoragePath,
                            acordMaxFileSize: fileConfig.acordMaxFileSize,
                            acordAllowedExtensions: fileConfig.acordAllowedExtensions,
                            acordUploadDirectory: fileConfig.acordUploadDirectory,
                            acordFileRetentionDays: fileConfig.acordFileRetentionDays,
                            docIsSecure: fileConfig.docIsSecure,
                            acordIsSecure: fileConfig.acordIsSecure,
                        });
                        this.configId.set(fileConfig.configId);
                        this.isfileConfigUpdate.set(true);
                    });
                } else {
                    console.error('Response is invalid or empty:', response);
                }
            },
            error: (error: any) => {
                console.error('Error fetching file config details:', error);
            }
        });
    }

    savefileConfig(payload: any) {
        this.systemAdminService.saveFileConfig(payload).subscribe({
            next: (response: any) => {
                if (response) {
                    this.toastService.addNotification({ message: "File config created", type: ToastType.Success });
                    // if response is success show the prompt
                }
            },
            error: (error: any) => {
                console.log("error", error);
            }
        })
    }

    updatefileConfig(configId: number, payload: any) {
        this.systemAdminService.updateFileConfig(configId, payload).subscribe({
            next: (response: any) => {
                if (response) {
                    this.isReadonly.set(true);
                    this.toastService.addNotification({ message: "File config successfully updated", type: ToastType.Success });
                    // if response is success show the prompt
                }
            },
            error: (error: any) => {
                console.log("error", error);
            }
        })
    }

    onFileConfigSubmit() {
        if (this.fileConfigForm.invalid) {
            this.fileConfigForm.markAllAsTouched();
            return;
        }

        const userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
        const userId = userDetails.userId;

        const rawPayload = this.fileConfigForm.getRawValue() as any;

        const payload = {
            ...rawPayload,
            docIsSecure: rawPayload.docIsSecure ? 1 : 0,
            acordIsSecure: rawPayload.acordIsSecure ? 1 : 0,
            createdUserId: userId,
            updatedUserId: userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
        };

        this.isfileConfigUpdate() ? this.updatefileConfig(this.configId(), payload) : this.savefileConfig(payload);
    }

    cancelClick(){
        this.getFileConfigDetails();
        this.isReadonly.set(true);
    }
}
